import { render } from "./OverviewTopBar.vue?vue&type=template&id=0ec52553&scoped=true"
import script from "./OverviewTopBar.vue?vue&type=script&lang=js"
export * from "./OverviewTopBar.vue?vue&type=script&lang=js"

import "./OverviewTopBar.vue?vue&type=style&index=0&id=0ec52553&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec52553"]])

export default __exports__